import { Component } from '@angular/core';
import { HotelService } from 'src/app/api/tourism/hotel.service';

@Component({
  selector: 'app-hotel-information-extends',
  templateUrl: './hotel-information-extends.component.html',
  styleUrls: ['./hotel-information-extends.component.css']
})
export class HotelInformationExtendsComponent {
  hotel: any = null;
  detail_typesbedroom: any = [];

  constructor(private hotelService: HotelService) {}

  init(param: any) {
    let data = param.hotel_data;
    console.log("received");
    console.log(data);
    this.hotel = data;
    this.detail_typesbedroom = data.hotelprices;

    // this.hotelService.get(data.id).subscribe({
    //   next: (data: any) => {
    //     this.hotel = data.data;
    //     this.detail_typesbedroom = this.hotel.hotelprices;
    //   }
    // });
  }

  close() {
    this.detail_typesbedroom = [];
  }
}
